import { gql } from '@apollo/client';

export const getQuoteParentArticleDataQuery = gql`
  query getQuoteParentArticleDataQuery($parentArticleId: ID!) {
    article(where: { id: $parentArticleId }) {
      id
      parentArticle {
        id
        title
        shortDescription
        slug
        author {
          id
          name
          username
        }
        coverImage {
          id
          publicUrl
          publicUrlTransformed
          _meta {
            public_id
            height
            width
          }
        }
        deactivated
      }
    }
  }
`;
